<template>
  <header ref="header">
    <div class="hero-center-section">
		<div class="left-text">Portfolio</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/24.png" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="hero-center-section">
		<div class="left-text">Cao Yuxuan</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/19.png" alt="">
					</div>
				</div>
			</div>
		</div>	
	</div>
	<div class="hero-center-section">
		<div class="left-text">Portfolio</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/20.png" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="hero-center-section">
		<div class="left-text">Cao Yuxuan</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/22.png" alt="">
					</div>
				</div>
			</div>
		</div>	
	</div>
	<div class="hero-center-section">
		<div class="left-text">Portfolio</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/05.jpg" alt="">
					</div>
				</div>
			</div>
		</div>	
	</div>
	<div class="hero-center-section">
		<div class="left-text">Cao Yuxuan</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/07.jpg" alt="">
					</div>
				</div>
			</div>
		</div>	
	</div>
			<div class="hero-center-section">
		<div class="left-text">Portfolio</div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="img-wrap">
						<img src="@/assets/img/background/02.jpeg" alt="">
					</div>
				</div>
			</div>
		</div>	
	</div>
		
	<div class="section padding-top-bottom over-hide z-bigger">
		<ul class="slide-buttons">
			<li v-for="(btn, i) in slideButtons" :key="btn.to" :class="{active: hoveredIndex === i}">
				<router-link
					:to="btn.to"
					class="hover-target"
					:data-hover="btn.hover"
					@mouseenter="handleMouseEnter(i)"
					@mouseleave="handleMouseLeave"
				>
					{{ btn.text }}
				</router-link>
			</li>
		</ul>
	</div>
		
	<!-- Link to page
	================================================== -->
	<a href="https://oyim.xyz/resume2025/" class="link-to-page hover-target" target="_blank"><img src="@/assets/img/oyim.png" alt=""></a>
			
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      hoveredIndex: null,
      slideButtons: [
        { to: '/web-design', text: 'Web Design', hover: 'web design' },
        { to: '/ui-design', text: 'UI Design', hover: 'UI design' },
        { to: '/aicg', text: 'AICG', hover: 'AICG' },
        { to: '/illustration', text: 'Illustration', hover: 'Illustration' },
        { to: '/graphic-design', text: 'Graphic Design', hover: 'Graphic design' },
        { to: '/video-editing', text: 'Video Editing', hover: 'Video editing' },
        { to: '/information', text: 'Information', hover: 'information' },
      ],
    };
  },
  mounted() {
    this.initializeAnimations();
  },
  activated() {
    this.initializeAnimations();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.path === '/') {
        vm.initializeAnimations();
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path === '/') {
      this.initializeAnimations();
    }
    next();
  },
  methods: {
    initializeAnimations() {
      this.$nextTick(() => {
        const sections = this.$refs.header.querySelectorAll('.hero-center-section');
        let currentIndex = 0;

        // 初始化：隐藏所有section
        sections.forEach(section => {
          section.classList.remove('show');
        });

        // 显示第一个section
        sections[0].classList.add('show');

        // 设置循环播放
        setInterval(() => {
          sections[currentIndex].classList.remove('show');
          currentIndex = (currentIndex + 1) % sections.length;
          sections[currentIndex].classList.add('show');
        }, 5000); // 每5秒切换一次
      });
    },
    handleMouseEnter(i) {
      this.hoveredIndex = i;
    },
    handleMouseLeave() {
      this.hoveredIndex = null;
    }
  }
};
</script>

<style scoped>
@import '@/assets/css/style.css';

.link-to-page img {
  height: 40px;
  width: auto;
}

@media (max-width: 767px) {
  /* 替换所有固定像素值为相对单位 */
  .padding-top-bottom {
    padding: 15vw 0 5vw 0;
  }

  .container {
    width: 100%;
    padding: 0 15px;
  }

  /* 确保容器不会溢出 */
  .container {
    padding: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }

  /* 修复图片包装器 */
  .img-wrap {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
    border-radius: 0;
    position: relative;
    transform: none !important;
  }

  .img-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* 修复栅格系统 */
  .row {
    margin: 0;
  }

  .col-md-8 {
    padding: 0;
    width: 100%;
  }

  /* 确保 hero section 不会溢出 */
  .hero-center-section {
    width: 100%;
    left: 0;
    right: 0;
    overflow: hidden;
  }

  /* 修复导航按钮 */
  .slide-buttons {
    width: 100%;
    padding: 0;
    margin: 0;
  }

  /* 修复 link-to-page */
  .link-to-page {
    width: 100vw;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}

* {
  box-sizing: border-box;
}

.container-name {  /* 比如 .web-design-container */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;
}

@media (max-width: 767px) {
  .container-name {
    padding: 1rem 0;
  }
}
</style> 